export default __webpack_public_path__ + "static/media/ConsCent-LogoIcon.a7d9d49b.svg";